import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mandant-logo-base64-scaled';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantLogoBase64ScaledEffects {

    MandantLogoBase64Scaled$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MANDANT_LOGO_BASE64_SCALED),
        mergeMap((x: ac.GetMandantLogoBase64ScaledAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMandantLogoBase64Scaled(x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetMandantLogoBase64ScaledErfolgreichAction(result, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMandantLogoBase64ScaledFehlerAction(error, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenService);
        }
        return this.service;
    }
}
